"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _shops = require("@module/shops");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Navigate() {
  var status = (0, _reactRedux.useSelector)(_shops.selectStatus);

  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['row']
    }, status === 'Active' ? /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
      level: 2,
      "data-locator": 'shop.header'
    }, "\u041C\u0430\u0433\u0430\u0437\u0438\u043D\u044B") : /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
      level: 2
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      className: _defaultModule["default"]['link'],
      to: process.env['PUBLIC_URL'] + '/shops',
      "data-locator": 'shop.header'
    }, "\u041C\u0430\u0433\u0430\u0437\u0438\u043D\u044B"))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['row']
    }, status === 'NotActive' ? /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
      level: 2,
      "data-locator": 'shop.header.inactive'
    }, "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u044B") : /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
      level: 2
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      className: _defaultModule["default"]['link'],
      to: process.env['PUBLIC_URL'] + '/shops/inactive',
      "data-locator": 'shop.header.inactive'
    }, "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u044B"))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Navigate;
exports["default"] = _default;